import React from 'react';
import { NavLink, Switch, Route } from "react-router-dom";
import {NotificationsLayout} from '../Layout';
import TagsNotifications from "../TagsNotifications";
import XLSXNotifications from "../XLSXNotifications";
import AutoNotifications from "../AutoNotifications";
import ReferralSystem from "../ReferralSystem";
import { useTranslation } from "react-i18next";
import styles from './profileNotifications.module.scss';
import {useCurrentBranch} from "../../../../hooks/useCurrentBranch";

export default function ProfileNotifications() {
  const {t} = useTranslation();
  const { currentRole } = useCurrentBranch()

  const navLinksContainer = () => {
    return (
      <div className={styles.navigation}>
        <NavLink to={'/profile/notifications'} exact activeClassName={styles.activeTab}>
          <span>{t('NSTag.tags')}</span>
        </NavLink>
        <NavLink to={'/profile/notifications/xlsx'} exact activeClassName={styles.activeTab}>
          <span>{t('xlsxMailing')}</span>
        </NavLink>
        <NavLink to={'/profile/notifications/referral'} exact activeClassName={styles.activeTab}>
          <span>{t('referral.system') || 'Реферальная система'}</span>
        </NavLink>
        <NavLink to={'/profile/notifications/auto'} exact activeClassName={styles.activeTab}>
          <span>{t('AutoNotifications.management')}</span>
        </NavLink>
      </div>
    )
  }

  return (
    <NotificationsLayout
      navLinksContainer={navLinksContainer}
    >
      <div className={styles.container}>
        <div className={styles.content}>
          <Switch>
            <Route path={'/profile/notifications'} exact render={() => <TagsNotifications/>}/>
            <Route path={'/profile/notifications/xlsx'} render={() => <XLSXNotifications/>}/>
            <Route path={'/profile/notifications/auto'} render={() => <AutoNotifications/>}/>
            <Route path={'/profile/notifications/referral'} render={() => <ReferralSystem/>}/>
          </Switch>
        </div>
      </div>
    </NotificationsLayout>
  )
}
